module.exports = __webpack_public_path__ + "img/default-image.93323511.jpg";